import { NgModule } from '@angular/core';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { ConditionsAcceptorComponent } from './components';

@NgModule({
	declarations: [ConditionsAcceptorComponent],
	exports: [ConditionsAcceptorComponent],
	imports: [SharedCommonModule, SharedComponentsModule]
})
export class UtilsModule {}
